import { ApolloCache, DefaultContext, MutationUpdaterFunction } from '@apollo/client';
import {
  ClientCreateInput,
  ClientCreateMutation,
  ClientsListDocument,
  ClientsListQuery,
  ClientsListQueryVariables,
  Exact,
} from 'generated/graphql';

type ClientEdge = ClientsListQuery['clients']['edges'][number];

const orderEdges = (edges: ClientEdge[]) =>
  edges.sort((a, b) => a.node!.fullName.localeCompare(b.node!.fullName));

export const updateCacheOnCreate: MutationUpdaterFunction<
  ClientCreateMutation,
  Exact<{ data: ClientCreateInput }>,
  DefaultContext,
  ApolloCache<any>
> = (cache, { data: mutationData }) => {
  if (mutationData) {
    cache.updateQuery<ClientsListQuery, ClientsListQueryVariables>(
      { query: ClientsListDocument },
      queryData => {
        if (queryData) {
          const { clientCreate: client } = mutationData;
          return {
            ...queryData,
            clients: {
              ...queryData.clients,
              edges: orderEdges([
                ...queryData.clients.edges,
                { __typename: 'ClientEdge', node: client },
              ]),
            },
          };
        }
        return null;
      }
    );
  }
};
